import { __ } from '@wordpress/i18n';
import { RawHTML, useEffect } from "@wordpress/element";
import { useBlockProps, InnerBlocks, InspectorControls, ColorPalette, MediaUpload, MediaUploadCheck, RichText } from '@wordpress/block-editor';
import { __experimentalHeading as Heading, PanelBody, ToggleControl, __experimentalUnitControl as UnitControl, RangeControl, Button, SelectControl } from '@wordpress/components';

export const edit = ({ clientId, attributes, setAttributes}) => {
    const {
        id,
        hfcFootInnerWidth,
        hfcFootBGcolor,
        hfcFootBorderColor,
        hfcCopyrightBGcolor,
        hfcFootMenuTitlesColor,
        hfcFootMenuLinksColor,
        hfcFootMenuLinksHoverColor,
        hfcFootMenuIconsColor,
        hfcFootMenuIconsHoverColor,
        hfcFootMenuIconsBGColor,
        hfcFootMenuIconsBGHoverColor,
        hfcFootMenuIconSize,
        hfcFootMenuItemFontSize,
        hfcFootMenuIconBGSize,
        hfcFootIconBorderColor,
        hfcFootIconBorderHoverColor,
        hfcFootIconBorderStyle,
        hfcFootIconBorderWidth,
        hfcFootBorderRadius,
        hfcFootContentGap,
        hfcFootItemsGap,
        hfcFootSocialIconsColor,
        hfcFootSocialIconsHoverColor,
        hfcHasFootBGimg,
        hfcFootBGimg,
        hfcFootBGimgObj,
        hfcFootBGolColor,
        hfcFootBGolRange,
        hfcHasCopyright,
        hfcCopyrightTxt
    } = attributes;

    useEffect(() => {
        if (!id) {
            // Set unique ID through block index only once.
            let clientIdSliced = clientId.slice(clientId.lastIndexOf("-") + 1);
            setAttributes({ id: 'hfc-footer-' + clientIdSliced });
        }
    }, [id, clientId, setAttributes]);

    // Define Block Props
    const blockProps = useBlockProps();

  // Updated icon list templates with correct icon objects
const iconListTemplate = [
    ['hfc-blocks/icon-list', {}, [
        ['hfc-blocks/list-item', { spanText: 'Privacy Policy', icon: "faAngleRight", isLinkable: true}],
        ['hfc-blocks/list-item', { spanText: 'Terms of Use', icon: "faAngleRight", isLinkable: true }],
        ['hfc-blocks/list-item', { spanText: 'DMCA', icon: "faAngleRight", isLinkable: true}],
        ['hfc-blocks/list-item', { spanText: 'CCPA', icon: "faAngleRight",isLinkable: true }]
    ]],
];

const iconListTemplateTwo = [
    ['hfc-blocks/icon-list', {}, [
        ['hfc-blocks/list-item', { spanText: 'Home', icon: "faAngleRight", isLinkable: true }],
        ['hfc-blocks/list-item', { spanText: 'About', icon: "faAngleRight", isLinkable: true }],
        ['hfc-blocks/list-item', { spanText: 'Blog', icon: "faAngleRight", isLinkable: true}],
        ['hfc-blocks/list-item', { spanText: 'Contact', icon: "faAngleRight", isLinkable: true }]
    ]],
];

const iconListTemplateThree = [
    ['hfc-blocks/icon-list', {}, [
        ['hfc-blocks/list-item', { spanText: '1600 Amphitheatre Parkway Mountain View, CA 94043 USA', icon: "faLocationDot" }],
        ['hfc-blocks/list-item', { spanText: '+1-800-419-0157', icon: "faPhone", isLinkable: true, url: 'tel:+1-800-419-0157' }],
        ['hfc-blocks/list-item', { spanText: 'support-in@google.com', icon: "faEnvelope", isLinkable: true, url: 'mailto:support-in@google.com'}]
    ]],
];
    const ALLOWED_BLOCKS = [
        'core/group',
        'core/columns',
        'core/column',
        'core/image',
        'core/heading',
        'core/paragraph',
        'core/social-links',
        'core/social-link',
        'core/navigation',
        'core/navigation-link',
        'core/buttons',
        'core/button'
    ];

    const TEMPLATE = [['core/group', {
        tagName: 'footer'
    }, [
        ['core/columns', {
            verticalAlignment: 'center',
            className: 'hfc-cols-footer-1'
        }, [
            ['core/column', {
                width: '40%',
                className: 'hfc-footer-site-about'
            }, [
                ['core/image', {
                    url: require('/public/img/hfc-footer-logo-demo.png'),
                    className: 'hfc-footer-site-about-logo'
                }],
                ['core/paragraph', {
                    content: 'Explore the world of seamless refunds and savvy savings. Join our community for the latest updates, expert insights, and exclusive offers. Your path to financial empowerment begins here.'
                }],
                ['core/social-links', { className: 'hfc-sl-footer-1' }, [
                    ['core/social-link', { service: 'facebook', url: '#' }],
                    ['core/social-link', { service: 'linkedin', url: '#' }],
                    ['core/social-link', { service: 'pinterest', url: '#' }]
                ]]
            ]],
            ['core/column', {
                width: '17%',
                className: 'hfc-footer-menu hfc-footer-menu-num-2',
            }, [
                ['core/heading', {
                    content: 'Useful Links',
                    level: 4
                }],
                ...iconListTemplate
            ]],
            ['core/column', {
                width: '17%',
                className: 'hfc-footer-menu hfc-footer-menu-num-2'
            }, [
                ['core/heading', {
                    content: 'Quick Links',
                    level: 4
                }],
                ...iconListTemplateTwo
            ]],
            ['core/column', {
                width: '26%',
                className: 'hfc-footer-menu hfc-footer-menu-num-3'
            }, [
                ['core/heading', {
                    content: 'Contact Info',
                    level: 4
                }],
                ...iconListTemplateThree
            ]],
        ]],
    ]]];

    const hfcDynamicStyles = `.editor-styles-wrapper {
        margin: 0;
    }
    .editor-styles-wrapper .wp-block {
        max-width: 100%!important;
        padding: 0px;
   }
    .wp-block-hfc-blocks-footer-1{
        max-width: 100% !important;
    }
    .editor-styles-wrapper .hfc-main-footer-1 .wp-block-navigation__container {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        gap: 10px;
    }
    .editor-styles-wrapper .hfc-main-footer-1 .wp-block a {
        text-decoration: none;
    }
    .editor-styles-wrapper .wp-block-post-content{
        padding: 0px;
    }
    .editor-styles-wrapper p.hfc-copyright-area{
        font-size: 16px;
    }
     #${id}.hfc-main-footer-1 .block-editor-block-list__block {
        color: #fff;
        font-size: 16px;
    }
    #${id}.hfc-main-footer-1 {
        background-color: ${hfcFootBGcolor};
    }
    .editor-styles-wrapper #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner svg{
       color: ${hfcFootMenuIconsColor}!important;
    }
    .editor-styles-wrapper #${id}.hfc-main-footer-1 .block-editor-inner-blocks > .block-editor-block-list__layout {
        display: flex;
        gap: ${hfcFootItemsGap}!important;
    }
    .editor-styles-wrapper #${id}.hfc-main-footer-1 a {
        text-decoration: none;
    }
    .editor-styles-wrapper #${id}.hfc-main-footer-1 .fp-ip-inner {
        gap: ${hfcFootContentGap}!important;
    }
    .editor-styles-wrapper #${id}.hfc-main-footer-1 span {
        margin: 0px;
        font-size: ${hfcFootMenuItemFontSize}!important;    
    }
    .editor-styles-wrapper #${id}.hfc-main-footer-1 .fp-ip-inner .fp-ip-icon{
        display: flex;
        background-color: ${hfcFootMenuIconsBGColor}!important;
        transition: 0.4s;
        padding: ${hfcFootMenuIconBGSize}!important;
        border-radius: ${hfcFootBorderRadius}!important;
        border-width: ${hfcFootIconBorderWidth}!important;
        border-style: ${hfcFootIconBorderStyle}!important;
        border-color: ${hfcFootIconBorderColor}!important;
    }
    .editor-styles-wrapper #${id}.hfc-main-footer-1 .fp-ip-inner:hover .fp-ip-icon{
        background-color: ${hfcFootMenuIconsBGHoverColor}!important;
        border-color: ${hfcFootIconBorderHoverColor}!important;
    }
    .editor-styles-wrapper #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner svg {
        color: ${hfcFootMenuIconsColor}!important;
        font-size: ${hfcFootMenuIconSize}!important;
        height: ${hfcFootMenuIconSize}!important;
        width: ${hfcFootMenuIconSize}!important;
        flex-shrink: 0;
    }
    .editor-styles-wrapper #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner:hover svg {
        color: ${hfcFootMenuIconsHoverColor}!important;
    }
    .editor-styles-wrapper #${id}.hfc-main-footer-1 .fp-ip-inner span,
    .editor-styles-wrapper #${id}.hfc-main-footer-1 .fp-ip-inner a{
        color: ${hfcFootMenuLinksColor}!important;
        font-size: ${hfcFootMenuItemFontSize}!important;
        line-height: 22px;
    }
    .editor-styles-wrapper #${id}.hfc-main-footer-1 .fp-ip-inner a{
       cursor: pointer;
    }
    .editor-styles-wrapper #${id}.hfc-main-footer-1 .fp-ip-inner:hover span,
    .editor-styles-wrapper #${id}.hfc-main-footer-1 .fp-ip-inner:hover a{
        color: ${hfcFootMenuLinksHoverColor}!important;
    }
     #${id}.hfc-main-footer-1 footer.wp-block-group {
        position: relative;
        padding: 70px 20px 50px!important;
        max-width: ${hfcFootInnerWidth}!important;
        margin: 0 auto;
        z-index: 9;
    }
     #${id}.hfc-main-footer-1 .hfc-footer-top-area {
        position: relative;
    }
     #${id}.hfc-main-footer-1 img.hfc-footer-bg-img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
     #${id}.hfc-main-footer-1 span.hfc-footer-img-overlay {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: ${hfcFootBGolColor};
        opacity: ${hfcFootBGolRange}%;
        z-index: 9;
    }
    #${id}.hfc-main-footer-1 .wp-block-group__inner-container {
        max-width: 100%;
        padding: 0;
    }
    #${id}.hfc-main-footer-1 .hfc-footer-menu-num-3 .wp-block-hfc-blocks-list-item:first-child .fp-ip-inner:hover span{
       color: ${hfcFootMenuLinksColor}!important;
    }
    #${id}.hfc-main-footer-1 .hfc-footer-menu-num-3 .wp-block-hfc-blocks-list-item:first-child .fp-ip-inner{
       align-items: flex-start!important;
    }
    #${id}.hfc-main-footer-1 .hfc-copyright-area {
        text-align: center;
        background: ${hfcCopyrightBGcolor};
        border-top: 1px solid ${hfcFootBorderColor};
        padding: 20px 10px;
        color: #fff;
        margin: 0 !important;
        max-width: 100% !important;
        font-size: 18px;
    }
    #${id}.hfc-main-footer-1 .wp-block-column.hfc-footer-site-about {
        padding-right: 40px;
    }
    #${id}.hfc-main-footer-1 .hfc-footer-site-about-logo img {
        display: block;
        margin-bottom: 20px;
    }
    #${id}.hfc-main-footer-1 .hfc-footer-site-about  p{
        padding-bottom: 20px;
        margin: 0px!important;
        font-size: 18px;
    }
    #${id}.hfc-main-footer-1 .wp-block-column.hfc-footer-menu .wp-block-heading {
        color: ${hfcFootMenuTitlesColor};
        font-size: 28px;
        line-height: 30px;
        font-weight: bold;
        margin-bottom: 15px;
        padding: 0px;
    }
    #${id} .hfc-nav-footer-1 {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        gap: 10px;
    }
    #${id}.hfc-main-footer-1 .wp-block-social-links.hfc-sl-footer-1 {
        margin: 0;
        display: flex;
        gap: 24px;
    }
    .editor-styles-wrapper .hfc-sl-footer-1 .wp-block-social-link-anchor,
    #${id}.hfc-main-footer-1 .wp-block-social-links.hfc-sl-footer-1 .wp-social-link {
        background: transparent;
        border: 0;
        transition: 0.4s;
    }
    #${id}.hfc-main-footer-1 .wp-block-social-links.hfc-sl-footer-1 .wp-social-link:hover{
        transform: scale(1.1);
    }
    #${id}.hfc-main-footer-1 .wp-block-social-links.hfc-sl-footer-1 .wp-block-social-link-anchor,
    #${id}.hfc-main-footer-1 .wp-block-social-links.hfc-sl-footer-1 .wp-social-link a {
        padding: 0;
    }
    #${id}.hfc-main-footer-1 .hfc-sl-footer-1 svg {
        width: 24px;
        height: 24px;
        fill: ${hfcFootSocialIconsColor}!important;
    }
    #${id}.hfc-main-footer-1 .hfc-sl-footer-1 svg:hover{
        width: 24px;
        height: 24px;
        fill: ${hfcFootSocialIconsHoverColor}!important;
    }
        /* Responsive */
    @media (max-width: 1200px) {
        .hfc-main-footer-1 .wp-block-column.hfc-footer-menu .wp-block-heading{
           font-size: 26px!important;
        }
         #${id}.hfc-main-footer-1 .hfc-footer-top-area {
            padding: 0 10px;
        }
    }
    @media (max-width: 1024px) {
       #${id}.hfc-main-footer-1 .wp-block-column.hfc-footer-site-about{
           padding-right: 0;
       }
        #${id}.hfc-main-footer-1 footer.wp-block-group .wp-block-columns.hfc-cols-footer-1{
            flex-wrap: wrap!important;
        }
        #${id}.hfc-main-footer-1 footer.wp-block-group .wp-block-columns.hfc-cols-footer-1 .wp-block-column {
            flex-basis: calc(50% - 12px) !important;
        }
    }
    @media (max-width: 599px) {
        #${id}.hfc-main-footer-1 footer.wp-block-group .wp-block-columns.hfc-cols-footer-1 .wp-block-column {
            flex-basis: 100% !important;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 0;
            text-align: center;
            margin-top: 20px;
        }
        #${id}.hfc-main-footer-1 .hfc-icon-list-main{
            margin-top: 0;
        }
        #${id}.hfc-main-footer-1 .wp-block-column.hfc-footer-site-about p,
        #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner span{
            text-align: left;
        }
        #${id}.hfc-main-footer-1 .hfc-nav-item-with-icon.hfc-n-ico-location {
            max-width: 270px;
            text-align: left;
        }
    }`;

    return ([
        <InspectorControls key={`inspector-controls-${id}`}>
            <PanelBody
                title={__('Cross Rating Block Settings')}
                icon={'admin-generic'}
                initialOpen={true}
                className={'frhd__control frhd__control-query'}
            >
                <UnitControl
                    label={__('Footer Inner Width :')}
                    onChange={newValue => setAttributes({ hfcFootInnerWidth: newValue })}
                    isUnitSelectTabbable
                    value={hfcFootInnerWidth}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Footer Background Color :</Heading>
                <ColorPalette
                    value={hfcFootBGcolor}
                    onChange={(colorValue) => setAttributes({ hfcFootBGcolor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Icon Color :</Heading>
                <ColorPalette
                    value={hfcFootMenuIconsColor}
                    onChange={(colorValue) => setAttributes({ hfcFootMenuIconsColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Icon Hover Color :</Heading>
                <ColorPalette
                    value={ hfcFootMenuIconsHoverColor}
                    onChange={(colorValue) => setAttributes({  hfcFootMenuIconsHoverColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Label Color :</Heading>
                <ColorPalette
                    value={hfcFootMenuLinksColor}
                    onChange={(colorValue) => setAttributes({ hfcFootMenuLinksColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Label Hover Color :</Heading>
                <ColorPalette
                    value={hfcFootMenuLinksHoverColor}
                    onChange={(colorValue) => setAttributes({ hfcFootMenuLinksHoverColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Icon Background Color :</Heading>
                <ColorPalette
                    value={ hfcFootMenuIconsBGColor}
                    onChange={(colorValue) => setAttributes({  hfcFootMenuIconsBGColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Icon Background Hover Color :</Heading>
                <ColorPalette
                    value={hfcFootMenuIconsBGHoverColor}
                    onChange={(colorValue) => setAttributes({ hfcFootMenuIconsBGHoverColor: colorValue })}
                    clearable={false}
                />
                <UnitControl
                    label={__('Icon Size :')}
                    onChange={newValue => setAttributes({ hfcFootMenuIconSize: newValue })}
                    isUnitSelectTabbable
                    value={hfcFootMenuIconSize}
                    className={'frhd__component frhd__component-width-90'}
                />
                <UnitControl
                    label={__('Icon Background Size :')}
                    onChange={newValue => setAttributes({ hfcFootMenuIconBGSize: newValue })}
                    isUnitSelectTabbable
                    value={hfcFootMenuIconBGSize}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Icon Background Border</Heading>
                <UnitControl
                    label={__('Border Width :')}
                    onChange={(newValue) => setAttributes({ hfcFootIconBorderWidth: newValue })}
                    isUnitSelectTabbable
                    value={hfcFootIconBorderWidth}
                    className={'frhd__component frhd__component-width-90'}
                />
                <SelectControl
                    label={__('Border Style :')}
                    value={hfcFootIconBorderStyle}
                    options={[
                        { label: __('None'), value: 'none' },
                        { label: __('Solid'), value: 'solid' },
                        { label: __('Dashed'), value: 'dashed' },
                        { label: __('Dotted'), value: 'dotted' },
                        { label: __('Double'), value: 'double' },
                    ]}
                    onChange={(newValue) => setAttributes({hfcFootIconBorderStyle: newValue })}
                    __nextHasNoMarginBottom
                />
                <Heading className={'frhd__pb-heading'}>Border Color :</Heading>
                <ColorPalette
                    value={hfcFootIconBorderColor}
                    onChange={(colorValue) => setAttributes({ hfcFootIconBorderColor: colorValue })}
                    clearable={false}
                />

                <Heading className={'frhd__pb-heading'}>Border Hover Color :</Heading>
                <ColorPalette
                    value={hfcFootIconBorderHoverColor}
                    onChange={(colorValue) => setAttributes({ hfcFootIconBorderHoverColor: colorValue })}
                    clearable={false}
                />
                <UnitControl
                    label={__('Icon Background Border Radius :')}
                    value={hfcFootBorderRadius}
                    onChange={(newValue) => setAttributes({ hfcFootBorderRadius: newValue })}
                    isUnitSelectTabbable
                    className={'frhd__component frhd__component-width-90'}
                />
                <UnitControl
                    label={__('Label Size :')}
                    onChange={newValue => setAttributes({hfcFootMenuItemFontSize: newValue })}
                    isUnitSelectTabbable
                    value={hfcFootMenuItemFontSize}
                    className={'frhd__component frhd__component-width-90'}
                />
                <UnitControl
                    label={__('Gap Between Icon & Label:')}
                    onChange={newValue => setAttributes({ hfcFootContentGap: newValue })}
                    isUnitSelectTabbable
                    value={hfcFootContentGap}
                    className={'frhd__component frhd__component-width-90'}
                />
                <UnitControl
                    label={__('Items Gap:')}
                    onChange={newValue => setAttributes({hfcFootItemsGap: newValue })}
                    isUnitSelectTabbable
                    value={hfcFootItemsGap}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Footer Border Color :</Heading>
                <ColorPalette
                    value={hfcFootBorderColor}
                    onChange={(colorValue) => setAttributes({ hfcFootBorderColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Copyright Background Color :</Heading>
                <ColorPalette
                    value={hfcCopyrightBGcolor}
                    onChange={(colorValue) => setAttributes({ hfcCopyrightBGcolor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Menu Titles Color :</Heading>
                <ColorPalette
                    value={hfcFootMenuTitlesColor}
                    onChange={(colorValue) => setAttributes({ hfcFootMenuTitlesColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Social Icons Color :</Heading>
                <ColorPalette
                    value={hfcFootSocialIconsColor}
                    onChange={(colorValue) => setAttributes({ hfcFootSocialIconsColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Social Icons Hover Color :</Heading>
                <ColorPalette
                    value={hfcFootSocialIconsHoverColor}
                    onChange={(colorValue) => setAttributes({ hfcFootSocialIconsHoverColor: colorValue })}
                    clearable={false}
                />
                <ToggleControl
                    label={
                        hfcHasFootBGimg
                            ? 'Footer Background Image :'
                            : 'Footer Background Image :'
                    }
                    checked={hfcHasFootBGimg}
                    onChange={newValue => setAttributes({ hfcHasFootBGimg: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                {hfcHasFootBGimg && (
                    <>
                        <Heading className={'frhd__pb-heading'}>Footer Background Image :</Heading>
                        <img src={hfcFootBGimg} className={'frhd__pb-media-upload-preview'} />
                        <MediaUploadCheck>
                            <MediaUpload
                                onSelect={(media) =>
                                    setAttributes({ hfcFootBGimgObj: media.sizes, hfcFootBGimg: media.sizes.full.url })
                                }
                                allowedTypes={['image']}
                                value={hfcFootBGimg}
                                render={({ open }) => (
                                    <Button
                                        onClick={open}
                                        icon={'admin-media'}
                                        className={'frhd__gr-media-btn button button-secondary'}
                                    >Open Media Library</Button>
                                )}
                            />
                        </MediaUploadCheck>
                        <Heading className={'frhd__pb-heading'}>Footer Overlay Color :</Heading>
                        <ColorPalette
                            value={hfcFootBGolColor}
                            onChange={(colorValue) => setAttributes({ hfcFootBGolColor: colorValue })}
                            clearable={false}
                        />
                        <RangeControl
                            label={'Footer Overlay Opacity :'}
                            value={hfcFootBGolRange}
                            onChange={(colorValue) => setAttributes({ hfcFootBGolRange: colorValue })}
                            min={0}
                            max={100}
                            __nextHasNoMarginBottom
                        />
                    </>
                )}
                <ToggleControl
                    label={
                        hfcHasCopyright
                            ? 'Show Copyright Area :'
                            : 'Show Copyright Area :'
                    }
                    checked={hfcHasCopyright}
                    onChange={newValue => setAttributes({ hfcHasCopyright: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
            </PanelBody>
        </InspectorControls>,
        <div {...blockProps} key={`${id}-main-blocks`}>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-main-footer-1'}>
                <div className='hfc-footer-top-area'>
                    {hfcHasFootBGimg && (
                        <>
                            <span className='hfc-footer-img-overlay'></span>
                            <img src={hfcFootBGimg} className='hfc-footer-bg-img' />
                        </>
                    )}
                    <InnerBlocks
                        allowedBlocks={ALLOWED_BLOCKS}
                        template={TEMPLATE}
                    />
                </div>
                {hfcHasCopyright && (
                    <RichText
                        {...blockProps}
                        tagName="p"
                        value={hfcCopyrightTxt}
                        onChange={(newValue) => setAttributes({ hfcCopyrightTxt: newValue })}
                        placeholder={__("Footer Copyright Text")}
                        className="hfc-copyright-area"
                    />
                )}
            </div>
        </div>
    ])
}

export const save = ({ attributes }) => {

    const {
        id,
        hfcFootInnerWidth,
        hfcFootBGcolor,
        hfcFootBorderColor,
        hfcCopyrightBGcolor,
        hfcFootMenuTitlesColor,
        hfcFootMenuLinksColor,
        hfcFootMenuLinksHoverColor,
        hfcFootMenuIconsColor,
        hfcFootMenuIconsHoverColor,
        hfcFootMenuIconsBGColor,
        hfcFootMenuIconsBGHoverColor,
        hfcFootMenuIconSize,
        hfcFootMenuItemFontSize,
        hfcFootMenuIconBGSize,
        hfcFootIconBorderColor,
        hfcFootIconBorderHoverColor,
        hfcFootIconBorderStyle,
        hfcFootIconBorderWidth,
        hfcFootBorderRadius,
        hfcFootContentGap,
        hfcFootItemsGap,
        hfcFootSocialIconsColor,
        hfcFootSocialIconsHoverColor,
        hfcHasFootBGimg,
        hfcFootBGimg,
        hfcFootBGimgObj,
        hfcFootBGolColor,
        hfcFootBGolRange,
        hfcHasCopyright,
        hfcCopyrightTxt
    } = attributes;

    const hfcDynamicStyles = `#${id}.hfc-main-footer-1 {
        background-color: ${hfcFootBGcolor};
        color: #fff;
    }
    #${id}.hfc-main-footer-1 footer.wp-block-group {
        position: relative;
        padding: 70px 20px 50px;
        max-width: ${hfcFootInnerWidth};
        margin: 0 auto;
        z-index: 9;
    }
    #${id}.hfc-main-footer-1 .hfc-footer-top-area {
        position: relative;
    }
    #${id}.hfc-main-footer-1 img.hfc-footer-bg-img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    #${id}.hfc-main-footer-1 span.hfc-footer-img-overlay {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: ${hfcFootBGolColor};
        opacity: ${hfcFootBGolRange}%;
        z-index: 9;
    }
    #${id}.hfc-main-footer-1 .wp-block-group__inner-container {
        max-width: 100%;
        padding: 0;
    }
    #${id}.hfc-main-footer-1 .hfc-footer-menu-num-3 .wp-block-hfc-blocks-list-item:first-child .fp-ip-inner:hover span{
       color: ${hfcFootMenuLinksColor}!important;
    }
    #${id}.hfc-main-footer-1 .hfc-icon-list-main{
        gap: ${hfcFootItemsGap};
    }
    #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner svg{
       color: ${hfcFootMenuIconsColor}!important;
    }
    #${id}.hfc-main-footer-1 a {
        text-decoration: none;
    }
    #${id}.hfc-main-footer-1 .fp-ip-inner {
        gap: ${hfcFootContentGap}!important;
    }
    #${id}.hfc-main-footer-1 span {
        margin: 0px;
        font-size: ${hfcFootMenuItemFontSize}!important;    
    }
    #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner .fp-ip-icon{
        display: flex;
        background-color: ${hfcFootMenuIconsBGColor}!important;
        transition: 0.4s;
        padding: ${hfcFootMenuIconBGSize}!important;
        border-radius: ${hfcFootBorderRadius}!important;
        border-width: ${hfcFootIconBorderWidth}!important;
        border-style: ${hfcFootIconBorderStyle}!important;
        border-color: ${hfcFootIconBorderColor}!important;
    }
    #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner:hover .fp-ip-icon{
        background-color: ${hfcFootMenuIconsBGHoverColor}!important;
        border-color: ${hfcFootIconBorderHoverColor}!important;
    }
    #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner svg{
        color: ${hfcFootMenuIconsColor}!important;
        font-size: ${hfcFootMenuIconSize}!important;
        height: ${hfcFootMenuIconSize}!important;
        width: ${hfcFootMenuIconSize}!important;
        flex-shrink: 0;
    }
    #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner:hover svg {
        color: ${hfcFootMenuIconsHoverColor}!important;
    }
    #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner span,
    #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner a{
        color: ${hfcFootMenuLinksColor}!important;
        font-size: ${hfcFootMenuItemFontSize}!important;
        line-height: 22px;
    }
    #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner a{
        cursor: pointer;
    }
    #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner:hover span,
     #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner:hover a{
        color: ${hfcFootMenuLinksHoverColor}!important;
    }
     #${id}.hfc-main-footer-1 .hfc-footer-menu-num-3 .wp-block-hfc-blocks-list-item:first-child .fp-ip-inner{
       align-items: flex-start!important;
    }
    #${id}.hfc-main-footer-1 .hfc-copyright-area {
        text-align: center;
        background: ${hfcCopyrightBGcolor};
        border-top: 1px solid ${hfcFootBorderColor};
        padding: 20px 10px;
        color: #fff;
        margin: 0 !important;
        max-width: 100% !important;
        font-size: 18px;
    }
    #${id}.hfc-main-footer-1 .wp-block-column.hfc-footer-site-about {
        padding-right: 40px;
    }
    #${id}.hfc-main-footer-1 .hfc-footer-site-about-logo img {
        display: block;
        margin-bottom: 20px;
    }
    #${id}.hfc-main-footer-1 .wp-block-column.hfc-footer-site-about p{
        padding-bottom: 20px;
        margin: 0px!important;
        font-size: 18px;
    }
    #${id}.hfc-main-footer-1 .wp-block-column.hfc-footer-menu .wp-block-heading {
        color: ${hfcFootMenuTitlesColor};
        font-size: 28px;
        line-height: 30px;
        font-weight: bold;
        margin-bottom: 15px;
        padding: 0px;
    }
    #${id}.hfc-main-footer-1 .wp-block-social-links.hfc-sl-footer-1 {
        margin: 0;
        display: flex;
        gap: 24px;
    }
    #${id}.hfc-main-footer-1 .wp-block-social-links.hfc-sl-footer-1 .wp-social-link {
        background: transparent!important;
    }
    #${id}.hfc-main-footer-1  .wp-block-social-links.hfc-sl-footer-1 .wp-social-link a {
        padding: 0;
    }
    #${id}.hfc-main-footer-1 .hfc-sl-footer-1 svg {
        width: 24px;
        height: 24px;
        fill: ${hfcFootSocialIconsColor}!important;
    }
     #${id}.hfc-main-footer-1 .hfc-sl-footer-1 svg:hover {
        fill: ${hfcFootSocialIconsHoverColor}!important;
    }

    /* Responsive */
    @media (max-width: 1200px) {
        .hfc-main-footer-1 .wp-block-column.hfc-footer-menu .wp-block-heading{
           font-size: 26px!important;
        }
         #${id}.hfc-main-footer-1 .hfc-footer-top-area {
            padding: 0 10px;
        }
    }
    @media (max-width: 1024px) {
       #${id}.hfc-main-footer-1 .wp-block-column.hfc-footer-site-about{
           padding-right: 0;
       }
        #${id}.hfc-main-footer-1 footer.wp-block-group .wp-block-columns.hfc-cols-footer-1{
            flex-wrap: wrap!important;
        }
        #${id}.hfc-main-footer-1 footer.wp-block-group .wp-block-columns.hfc-cols-footer-1 .wp-block-column {
            flex-basis: calc(50% - 12px) !important;
        }
    }
    @media (max-width: 599px) {
        #${id}.hfc-main-footer-1 footer.wp-block-group .wp-block-columns.hfc-cols-footer-1 .wp-block-column {
            flex-basis: 100% !important;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 0;
            text-align: center;
            margin-top: 20px;
        }
        #${id}.hfc-main-footer-1 .hfc-icon-list-main{
            margin-top: 0;
        }
        #${id}.hfc-main-footer-1 .wp-block-column.hfc-footer-site-about p,
        #${id}.hfc-main-footer-1 .hfc-icon-list-main .fp-ip-inner span{
            text-align: left;
        }
        #${id}.hfc-main-footer-1 .hfc-nav-item-with-icon.hfc-n-ico-location {
            max-width: 270px;
            text-align: left;
        }
    }`;

    return (
        <>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-main-footer-1'}>
                <div className='hfc-footer-top-area'>
                    {hfcHasFootBGimg && (
                        <>
                            <span className='hfc-footer-img-overlay'></span>
                            <img src={hfcFootBGimg} className='hfc-footer-bg-img' />
                        </>
                    )}
                    <InnerBlocks.Content />
                </div>
                {hfcHasCopyright && (
                    <RichText.Content
                        tagName='p'
                        value={hfcCopyrightTxt}
                        className="hfc-copyright-area"
                    />
                )}
            </div>
        </>
    )
}